var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',{attrs:{"path":_vm.localeKey,"tag":"p"},scopedSlots:_vm._u([_vm._l((_vm.extract_urls(_vm.localeKey)),function(url){return {key:url,fn:function(){return [_c('a',{key:url,attrs:{"href":_vm.$t(url)}},[_vm._v(" "+_vm._s(_vm.$t(url))+" ")])]},proxy:true}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }